document.addEventListener("DOMContentLoaded", function () {
  // Select all sections (each section will have a unique ID)
  const sections = document.querySelectorAll(".product-tab-block-custom");

  // Iterate through each section and add the event listener
  sections.forEach(function (section) {
    // Select all tab links within this section
    const tabLinks = section.querySelectorAll(".list-product-tabs .tab-links");
    // Select all tab images within this section
    const tabImages = section.querySelectorAll(".tab-image");
    // Select all tab content within this section
    const tabContents = section.querySelectorAll(
      ".product-tabs-content .tab-content"
    );

    // Add click event listener to each tab link in this section
    tabLinks.forEach(function (tabLink) {
      tabLink.addEventListener("click", function () {
        // Hide all images in this section
        tabImages.forEach(function (image) {
          image.style.display = "none";
        });

        // Hide all tab content in this section
        tabContents.forEach(function (content) {
          content.style.display = "none";
        });

        // Show the image and tab content associated with the clicked tab in this section
        const targetImage = section.querySelector(
          tabLink.getAttribute("data-target")
        );
        const targetTabContent = section.querySelector(
          tabLink.getAttribute("data-tab-content")
        );

        if (targetImage) {
          targetImage.style.display = "block";
        }

        if (targetTabContent) {
          targetTabContent.style.display = "block";
        }
      });
    });

    // Optional: Ensure the first tab's image and content are shown on page load for each section
    if (tabImages.length > 0 && tabContents.length > 0) {
      tabImages[0].style.display = "block";
      tabContents[0].style.display = "block";
    }
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//     // Select the carousel element
//     const productCarousel = document.querySelector('.complementary-products-slider .products-carousel');
    
//     if (productCarousel) {
//         // Initialize Slick slider with custom settings
//         $(productCarousel).slick({
//             dots: true,
//             infinite: false,
//             speed: 300,
//             slidesToShow: 2,
//             slidesToScroll: 1,
//             responsive: [
//                 {
//                     breakpoint: 1024,
//                     settings: {
//                         slidesToShow: 3,
//                         slidesToScroll: 3,
//                         infinite: true,
//                         dots: true
//                     }
//                 },
//                 {
//                     breakpoint: 600,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 2
//                     }
//                 },
//                 {
//                     breakpoint: 480,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1
//                     }
//                 }
//                 // You can unslick at a given breakpoint now by adding:
//                 // settings: "unslick"
//                 // instead of a settings object
//             ]
//         });
//     }
// });


document.addEventListener("DOMContentLoaded", function () {
  // Initialize slick slider
  const timelineSlider = document.querySelector('.timelineslider');

  // Initialize slick
  if (timelineSlider) {
    const slickSettings = {
      dots: false,
      arrows: false,
      speed: 500,
      cssEase: 'ease',
      swipeToSlide: true,
      focusOnSelect: false,
      slidesToShow: 1.3,
      swipe: false,  // Disable touch swipe functionality
      centerMode: false,
      infinite: false,
      leftPadding: '20%',
      // rtl: false
    };

    $(timelineSlider).slick(slickSettings);

    // Update slick settings on window resize
    function updateSlickSettings() {
      if (window.innerWidth > 991) {
        $(timelineSlider).slick('slickSetOption', {
          centerMode: false,
          slidesToShow: 1.3,
          // leftPadding: '0%',
          swipeToSlide: false,
          swipe: false,  // Disable touch swipe functionality
          infinite: false,
          focusOnSelect: true
        }, true);
      } else {
        $(timelineSlider).slick('slickSetOption', {
          centerMode: false,
          leftPadding: '20%',
          swipeToSlide: true,
          slidesToShow: 1,
          focusOnSelect: false
        }, true);
      }
    }

    // Listen for window resize to update slick settings
    window.addEventListener('resize', updateSlickSettings);
    updateSlickSettings(); // Set initial settings

    // Handle click on timeline-item
    const timelineItems = document.querySelectorAll('.timeline-item');
    
    // Add 'active' class to the first timeline item on load
    if (timelineItems.length > 0) {
      timelineItems[0].classList.add('active');
    }

    timelineItems.forEach(item => {
      item.addEventListener('click', function () {
        const clickedIndex = this.getAttribute('data-index'); // Get data-index of clicked timeline item

        // Find the slick slide that matches the clicked index
        const slides = document.querySelectorAll('.slick-slide');
        slides.forEach(slide => {
          const slideIndex = slide.getAttribute('data-slick-index'); // Get the data-slick-index of the current slide
          if (clickedIndex === slideIndex) {
            $(timelineSlider).slick('slickGoTo', slideIndex); // Go to the corresponding slide
          }
        });

        // Highlight the active timeline item
        timelineItems.forEach(item => item.classList.remove('active'));
        this.classList.add('active');
      });
    });

    // After slide change, update the active timeline item
    $(timelineSlider).on('afterChange', function(event, slick, currentSlide) {
      // Remove the 'active' class from all timeline items
      timelineItems.forEach(item => item.classList.remove('active'));

      // Add the 'active' class to the timeline item corresponding to the current slide
      const currentTimelineItem = document.querySelector(`.timeline-item[data-index="${currentSlide}"]`);
      if (currentTimelineItem) {
        currentTimelineItem.classList.add('active');
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const timelineWrappers = document.querySelectorAll(".product-tab-block .list-product-tabs");

  timelineWrappers.forEach((timelineWrapper) => {
    const items = timelineWrapper.querySelectorAll("li");

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse drag functionality
    timelineWrapper.addEventListener("mousedown", (e) => {
      isDown = true;
      timelineWrapper.classList.add("active");
      startX = e.pageX - timelineWrapper.offsetLeft;
      scrollLeft = timelineWrapper.scrollLeft;
    });

    timelineWrapper.addEventListener("mouseleave", () => {
      isDown = false;
      timelineWrapper.classList.remove("active");
    });

    timelineWrapper.addEventListener("mouseup", () => {
      isDown = false;
      timelineWrapper.classList.remove("active");
    });

    timelineWrapper.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - timelineWrapper.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed (adjust multiplier for faster/slower scroll)
      timelineWrapper.scrollLeft = scrollLeft - walk;
    });
  });
});




